import { render, staticRenderFns } from "./MyCompanyClientsEdit.vue?vue&type=template&id=37c82dd4&"
import script from "./MyCompanyClientsEdit.vue?vue&type=script&lang=js&"
export * from "./MyCompanyClientsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports